"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createAuthMiddleware", {
  enumerable: true,
  get: function get() {
    return _auth.default;
  }
});
Object.defineProperty(exports, "createAuthReducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "clearTokenAction", {
  enumerable: true,
  get: function get() {
    return _actions.clearTokenAction;
  }
});
Object.defineProperty(exports, "setTokenAction", {
  enumerable: true,
  get: function get() {
    return _actions.setTokenAction;
  }
});
Object.defineProperty(exports, "calculateJWTTokenExpirationDate", {
  enumerable: true,
  get: function get() {
    return _helpers.calculateJWTTokenExpirationDate;
  }
});
Object.defineProperty(exports, "calculateOauthTokenExpirationDate", {
  enumerable: true,
  get: function get() {
    return _helpers.calculateOauthTokenExpirationDate;
  }
});
Object.defineProperty(exports, "SET_TOKEN", {
  enumerable: true,
  get: function get() {
    return _types.SET_TOKEN;
  }
});
Object.defineProperty(exports, "CLEAR_TOKEN", {
  enumerable: true,
  get: function get() {
    return _types.CLEAR_TOKEN;
  }
});
Object.defineProperty(exports, "REFRESH_TOKEN_REQUEST", {
  enumerable: true,
  get: function get() {
    return _types.REFRESH_TOKEN_REQUEST;
  }
});
Object.defineProperty(exports, "REFRESH_TOKEN_FAILURE", {
  enumerable: true,
  get: function get() {
    return _types.REFRESH_TOKEN_FAILURE;
  }
});
Object.defineProperty(exports, "REFRESH_TOKEN_SUCCESS", {
  enumerable: true,
  get: function get() {
    return _types.REFRESH_TOKEN_SUCCESS;
  }
});

var _auth = _interopRequireDefault(require("./auth.middleware"));

var _reducer = _interopRequireDefault(require("./store/reducer"));

var _actions = require("./store/actions");

var _helpers = require("./helpers");

var _types = require("./store/types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}